/**
 * MobileCard - Reusable component for displaying table data as cards on mobile
 * Usage: Wrap your data items with MobileCard for responsive display
 */

import { cn } from '../lib/utils';

export const MobileCardContainer = ({ children, className }) => {
  return (
    <div className={cn("md:hidden space-y-3", className)}>
      {children}
    </div>
  );
};

export const MobileCard = ({ children, className, onClick, testId }) => {
  return (
    <div 
      className={cn(
        "bg-card border rounded-xl p-4 space-y-3",
        onClick && "cursor-pointer hover:bg-accent/50 transition-colors",
        className
      )}
      onClick={onClick}
      data-testid={testId}
    >
      {children}
    </div>
  );
};

export const MobileCardHeader = ({ children, className }) => {
  return (
    <div className={cn("flex items-start justify-between gap-2", className)}>
      {children}
    </div>
  );
};

export const MobileCardTitle = ({ children, className }) => {
  return (
    <div className={cn("font-medium", className)}>
      {children}
    </div>
  );
};

export const MobileCardContent = ({ children, className }) => {
  return (
    <div className={cn("space-y-2 text-sm", className)}>
      {children}
    </div>
  );
};

export const MobileCardRow = ({ label, value, className, valueClassName }) => {
  return (
    <div className={cn("flex justify-between items-center", className)}>
      <span className="text-muted-foreground">{label}</span>
      <span className={cn("font-medium", valueClassName)}>{value}</span>
    </div>
  );
};

export const MobileCardFooter = ({ children, className }) => {
  return (
    <div className={cn("flex items-center justify-end gap-2 pt-2 border-t", className)}>
      {children}
    </div>
  );
};

export default MobileCard;
